"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AdvancedModal = _interopRequireDefault(require("../../AdvancedModal"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _InputSelect = _interopRequireDefault(require("chaire-lib-frontend/lib/components/input/InputSelect"));
var _InputString = _interopRequireDefault(require("chaire-lib-frontend/lib/components/input/InputString"));
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
class MapScaleManagerSelector extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      selectedScale: _ServiceLocator.default.selectedScale && _OctaviParameters.default.get('selectedScale', null),
      scaleSplits: _ServiceLocator.default.selectedScale && _OctaviParameters.default.get('mapScale', [])
    };
    this.selectedScaleChoices = [{
      value: "intervalBased"
    }, {
      value: "distributionBased"
    }
    // TODO Support custom scale
    //{value: "custom"}
    ];
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.onScaleChange = this.onScaleChange.bind(this);
    this.isScaleValide = this.isScaleValide.bind(this);
    this.onScaleValueChange = this.onScaleValueChange.bind(this);
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on("taxi.filter.mapScaleManager.request", this.handleOpen);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off("taxi.filter.mapScaleManager.request", this.handleOpen);
  }
  handleOpen() {
    this.setState({
      isActive: true,
      scaleSplits: _ServiceLocator.default.selectedScale && _OctaviParameters.default.get('mapScale', [])
    });
  }
  handleClose() {
    this.setState({
      isActive: false
    });
  }
  handleConfirm() {
    _OctaviParameters.default['selectedScale'] = this.state.selectedScale;
    _ServiceLocator.default.eventManager.emit('taxi.filter.selectedScale.update', {
      type: this.state.selectedScale,
      splits: this.state.scaleSplits
    });
  }
  onScaleChange(e) {
    this.setState({
      selectedScale: e.target.value
    });
  }
  onScaleValueChange(e, idx) {
    const newScale = (0, _toConsumableArray2.default)(this.state.scaleSplits);
    newScale[idx] = parseFloat(e.target.value);
    this.setState({
      scaleSplits: newScale
    });
  }
  isScaleValide() {
    return true;
    // TODO Support custom scales
    if (this.state.selectedScale === "custom") {
      return this.state.scaleSplits.length > 0 && this.state.scaleSplits.every((value, idx, splits) => !idx || splits[idx - 1] <= value);
    } else {
      return true;
    }
  }
  renderContainer() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:scaleOptions:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: this.selectedScaleChoices,
      t: this.props.t,
      value: this.state.selectedScale ? this.state.selectedScale : "intervalBased",
      localePrefix: "octavi:widgetOptions:scaleOptions",
      onValueChange: e => this.onScaleChange(e),
      noBlank: true
    }))), /* TODO Support custom scales */false && this.state.selectedScale && this.state.selectedScale === "custom" && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, this.props.t('octavi:widgetOptions:customScaleOptions:title')), !this.isScaleValide() && /*#__PURE__*/_react.default.createElement("div", {
      className: "_error"
    }, this.props.t('octavi:widgetOptions:customScaleOptions:error')), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_third_column right"
    }, this.props.t('octavi:widgetOptions:customScaleOptions:minValue')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_three_columns"
    }, /*#__PURE__*/_react.default.createElement(_InputString.default, {
      value: this.state.scaleSplits[0],
      type: 'number',
      disabled: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_third_column right"
    }, this.props.t('octavi:widgetOptions:customScaleOptions:break_1')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_three_columns"
    }, /*#__PURE__*/_react.default.createElement(_InputString.default, {
      value: this.state.scaleSplits[1],
      type: 'number',
      onValueChange: e => this.onScaleValueChange(e, 1)
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_third_column right"
    }, this.props.t('octavi:widgetOptions:customScaleOptions:break_2')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_three_columns"
    }, /*#__PURE__*/_react.default.createElement(_InputString.default, {
      value: this.state.scaleSplits[2],
      type: 'number',
      onValueChange: e => this.onScaleValueChange(e, 2)
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_third_column right"
    }, this.props.t('octavi:widgetOptions:customScaleOptions:break_3')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_three_columns"
    }, /*#__PURE__*/_react.default.createElement(_InputString.default, {
      value: this.state.scaleSplits[3],
      type: 'number',
      onValueChange: e => this.onScaleValueChange(e, 3)
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_third_column right"
    }, this.props.t('octavi:widgetOptions:customScaleOptions:break_4')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_three_columns"
    }, /*#__PURE__*/_react.default.createElement(_InputString.default, {
      value: this.state.scaleSplits[4],
      type: 'number',
      onValueChange: e => this.onScaleValueChange(e, 4)
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_third_column right"
    }, this.props.t('octavi:widgetOptions:customScaleOptions:maxValue')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_three_columns"
    }, /*#__PURE__*/_react.default.createElement(_InputString.default, {
      value: this.state.scaleSplits[5],
      type: 'number',
      disabled: true
    })))));
  }
  render() {
    const {
      isActive,
      selected
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_AdvancedModal.default, {
      title: this.props.t('octavi:widgetOptions:scaleOptions:popupTitle'),
      t: this.props.t,
      isOpen: isActive,
      container: this.renderContainer(),
      showCancelButton: true,
      showConfirmButton: true,
      closeModal: this.handleClose,
      confirmAction: this.handleConfirm,
      isConfirmButtonDisabled: !this.isScaleValide()
    });
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(MapScaleManagerSelector);
MapScaleManagerSelector.propTypes = {
  activeSection: _propTypes.default.string
};